import { logger } from "@/lib/logger";

/**
 * Single integration point for error reporting.
 *
 * Today this routes to the structured `logger` so unhandled errors caught by the
 * App Router error boundaries (`app/error.tsx`, `app/global-error.tsx`) leave a
 * trace in server/browser logs. When a real provider (e.g. Sentry) is wired up,
 * drop the SDK call HERE — every boundary already calls this, so no other file
 * needs to change. Adding Sentry also requires allowing its ingest host in the
 * `connect-src` CSP directive in `next.config.mjs`.
 */
export function captureException(
  error: unknown,
  context?: Record<string, unknown>,
) {
  const err = error instanceof Error ? error : new Error(String(error));
  logger.error(err.message, {
    name: err.name,
    stack: err.stack,
    ...context,
  });
  // Sentry.captureException(err, { extra: context });
}
